import React from 'react';
import { DetailCardType } from 'types/DetailPageTypes';
import { FieldType } from 'types/FieldTypes';
import { TabType } from 'types/TabTypes';
import DetailPage from 'components/layout/DetailPage';

const EmployeeDetail: React.FC = () => {

    // Specify the parameters of this detail page:
    const apiObject = 'employee'
    const pageObject = 'employee'

    // Show the name of the linked user as a read-only header title:
    const headerTitleDataField = 'full_name'

    // Define the detail page tabs:
    const tabs: TabType[] = [
        { label: 'timeline.general.timeline_label', type: 'timeline', showOnlyTimelineUpdates: true },
        { label: 'employee.general.timetable_tab_label', type: 'timetable' },
    ]

    // Define detail components and add fields to FieldsCards:
    const detailCards: DetailCardType[] = [
        {
            component: 'FieldsCard',
            title: 'employee.general.general_details_card_label',
            alignment: 'horizontal',
            fields: [
                {
                    type: 'text',
                    name: 'number',
                    label: 'employee.general.number_label',
                    placeholder: 'employee.general.number_placeholder',
                },
                {
                    type: 'date',
                    name: 'date_of_employment',
                    label: 'employee.general.date_of_employment_label',
                },
                {
                    type: 'price',
                    name: 'cost_price',
                    label: 'employee.general.cost_price_label',
                    apiObject: 'currency',
                },
            ] as FieldType[],
        },
    ]

    return (
        <DetailPage
            apiObject={apiObject}
            pageObject={pageObject}
            headerTitleDataField={headerTitleDataField}
            detailCards={detailCards}
            tabs={tabs}
        />
    );
};

export default EmployeeDetail;
